import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './assets/style/common.less'
import './assets/style/lib.less'
import './assets/icon/iconfont.css';
import 'animate.css/animate.min.css';
Vue.use(ViewUI);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false;
import * as api from './lib/api';
Vue.prototype.$api = api;
import {static_url} from './lib/config';
Vue.prototype.$static_url = static_url;
//引入XEUtils
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
Vue.use(VXEUtils)
Vue.prototype.$xe = XEUtils;
// 全局mixins
import base from '@/lib/base';
// 添加过滤器
import {filters} from '@/lib/filters';
// 定义全局自定义过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
Vue.prototype.$Message.config({
    top: 200,
    duration: 3
});
Vue.mixin(base);
new Vue({
    router,
    store,
    render: h => h(App),
    // mounted () {
    //     document.dispatchEvent(new Event('render-event'))
    // }
}).$mount('#app')
